module.exports = __webpack_public_path__ + "images/emoji/last_quarter_moon.dde5188a609b5933ce2c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/last_quarter_moon.png
// module id = m7wR
// module chunks = 2